import { render, staticRenderFns } from "./VerInscripcionDialog.vue?vue&type=template&id=c816189e&"
import script from "./VerInscripcionDialog.vue?vue&type=script&lang=js&"
export * from "./VerInscripcionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports